import React from 'react';

// eslint-disable-next-line react/prop-types
const FlagshipNotification = ({ children, className }) => (
  <div className={`c-flagship-notification ${className || ''}`}>
    {children}
  </div>
);

export default FlagshipNotification;



// WEBPACK FOOTER //
// ./src/app/notifications/shared/FlagshipNotification.jsx